import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import AboutUs from '../views/aboutUs.vue'
import contactUs from '../views/contactUs.vue'
import otherLogin from '../views/login/otherLogin.vue'
import LoginWechat from '../views/login/wechat.vue'
import LoginAlipay from '../views/login/alipay.vue'
import Confirm from '../views/confirm/confirm.vue'
import Result from '../views/result/result.vue'
import Order from '../views/order/order.vue'
import Setting from '../views/setting/setting.vue'
import Help from '../views/help/help.vue'
import selectPakage from '../views/selectPakage/selectPakage.vue'
import packageOrder from '../views/packageOrder/packageOrder.vue'
import scanOrder from '../views/scanOrder/scanOrder.vue'
import scanPickUpOrder from '../views/scanPickUpOrder/scanPickUpOrder.vue'
import borrowSuccess from '../views/borrowSuccess/borrowSuccess.vue'
import payMethod from '../views/payMethod/payMethod.vue'
import packageDetail from '../views/packageDetail/packageDetail.vue'
import orderDetail from '../views/orderDetail/orderDetail.vue'
import homeMap from 'views/homeMap/homeMap.vue'
import pastOrder from '../views/pastOrder/pastOrder.vue'
import scanQr from '../views/scanQr/scanQr.vue'
import activityDevice from '../views/activition/activityDevice.vue'
import deviceManager from '../views/deviceManager/deviceManager.vue'
import PurchasedPackages from '../views/PurchasedPackages/PurchasedPackages.vue'
import product from '../views/product/product.vue'
import recharge from '../views/recharge/recharge.vue'
import certify from '../views/certify/certify.vue'
import check from '../views/check/check.vue'
import switchCard from '../views/switchCard/switchCard.vue'
import homeUd from '../views/homeUd/homeUd.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: otherLogin,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/otherLogin',
    name: 'otherLogin',
    component: otherLogin,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/',
    name: 'homeUd',
    component: homeUd,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/homeUd',
    name: 'homeUd',
    component: homeUd
  },
  {
    path: '/login_wechat',
    name: 'login_wechat',
    component: LoginWechat,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/certify',
    name: 'certify',
    component: certify
  },
  {
    path: '/switchCard',
    name: 'switchCard',
    component: switchCard
  },
  {
    path: '/login_alipay',
    name: 'login_alipay',
    component: LoginAlipay,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: AboutUs,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: contactUs,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: Confirm
  },
  {
    path: '/result',
    name: 'result',
    component: Result
  },
  {
    path: '/order',
    name: 'order',
    component: Order
  },
  {
    path: '/setting',
    name: 'setting',
    component: Setting
  },
  {
    path: '/help',
    name: 'help',
    component: Help
  },
  {
    path: '/selectPakage',
    name: 'selectPakage',
    component: selectPakage
  },
  {
    path: '/packageOrder',
    name: 'packageOrder',
    component: packageOrder,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/scanOrder',
    name: 'scanOrder',
    component: scanOrder
  },
  {
    path: '/scanPickUpOrder',
    name: 'scanPickUpOrder',
    component: scanPickUpOrder
  },
  {
    path: '/borrowSuccess',
    name: 'borrowSuccess',
    component: borrowSuccess
  },
  {
    path: '/payMethod',
    name: 'payMethod',
    component: payMethod,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/packageDetail',
    name: 'packageDetail',
    component: packageDetail
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: orderDetail
  },
  {
    path: '/homeMap',
    name: 'homeMap',
    component: homeMap
  },
  {
    path: '/pastOrder',
    name: 'pastOrder',
    component: pastOrder
  },
  {
    path: '/scanQr',
    name: 'scanQr',
    component: scanQr
  },
  {
    path: '/check',
    name: 'check',
    component: check
  },
  {
    path: '/deviceManager',
    name: 'deviceManager',
    component: deviceManager
  },
  {
    path: '/activityDevice',
    name: 'activityDevice',
    component: activityDevice,
    meta: {
      ignoreAuth: true
    }
  },
  {
    path: '/PurchasedPackages',
    name: 'PurchasedPackages',
    component: PurchasedPackages
  },
  {
    path: '/product',
    name: 'product',
    component: product
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: recharge
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log('to', to)
  const token = store.state.token
  if (to.name === 'home') {
    if (to.query.qrcode) {
      store.commit('qrcode', to.query.qrcode)
      store.commit('zhcode', '')
    }
    if (to.query.zhcode) {
      store.commit('zhcode', to.query.zhcode)
      store.commit('qrcode', '')
    }
  }
  if (to.query.AppleIdToken) {
    store.commit('appleIdToken', to.query.AppleIdToken)
  }
  if (to.matched.some(r => r.meta.ignoreAuth) || token) {
    next()
  } else {
    next({
      path: '/otherLogin'
    })
  }
})

export default router
